<template>
    <div>
        <vs-popup title="" 
            :button-close-hidden="true" 
            :active.sync="isActive" 
            @close="$emit('isActiveFalse')"
            style="border-radius: 10px !important;"
            id="popUpPayment"
        >
            <div>
                <span id="display-span-orders">
                    <vs-icon @click="isCreateContext ? (dataOfProductsToPreOrder.hasOwnProperty('product') ? $emit('backToDelivery') : $emit('backToProducts', context = 'serviceContext')) : $emit('backToOrderSummary', 'payment')" class="mr-2" icon="keyboard_arrow_left" style="border: solid 1px; border-radius: 14px; cursor: pointer;"/>
                    <p class="ml-2" style="font-size: 16px; width: 400px;">Pagamento (opcional)</p>
                    <div class="flex-end-align">
                        <vs-icon @click="closePopUp" class="mr-2" icon="close" style="-webkit-transform: scaleX(-1); transform: scaleX(-1); float: right;"></vs-icon>
                    </div>
                </span>
            </div>

            <vs-collapse accordion :key="collapseKey">

                    <div class="background-payment mt-4">
                    <h3 class="font-bold">Selecione o método de pagamento:</h3>

                    <div class="payment-card">
                        <vs-collapse-item
                            v-for="(check, index) in checks"
                            :key="index"
                            not-arrow 
                            class="w-full p-3"
                            :open="check.selected"
                        >
                            <div slot="header" style="padding:0 !important;" @click="handleCheckboxClick(check.type)">
                                <vs-checkbox v-model="check.selected" icon="none">
                                    <h4>{{ check.name }}</h4>
                                </vs-checkbox>
                            </div>

                            <div v-if="check.type === 'cash'">
                                <span class="mb-1 font-semi-bold" style="display: block;"> Troco Para: </span>
                                <div :class="{ 'highlight': isInputFocused, 'money-div': !isInputFocused }" class="w-full" >
                                    <span class="p-2 pr-1" style="font-size: 13.8px;">R$</span>
                                    <vs-input 
                                        @focus="highlightInput" 
                                        @blur="highlightInput" 
                                        v-mask=" ['#.##','##.##','###.##','####.##','#####.##','######.##',]" 
                                        v-model="money_change" 
                                        id="myinput"
                                        class="w-full"
                                        :max="10"
                                    />          
                                </div>
                            </div>

                            <div v-else-if="check.type === 'card'" style="margin-bottom:3.5em;" >
                                <div class="d-flex justify-content-between mt-3 font-bold">
                                    <p class="ml-1" style="width: 30em;">Modalidade do Cartão</p>
                                    <p class="ml-5" v-if="paymentModality === 'Crédito'">Quantidade de Parcelas</p>
                                </div>
                                <div class="d-flex justify-content-between mt-3">
                                    <v-select
                                        v-model="paymentModality"
                                        :options="['Crédito', 'Débito']"
                                        style="width: 30em;"
                                        class="ml-1"
                                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                                        :clearable="false"
                                    />
                                        
                                    <vs-input-number 
                                        v-model="months" 
                                        v-if="paymentModality === 'Crédito'" 
                                        min="1" 
                                        max="12"
                                        style="width: 15em;"
                                        class="ml-5"
                                    />
                                </div>
                            </div>
                    
                        </vs-collapse-item>

                    </div>
                </div>

            </vs-collapse>

            <div class="mt-2">
                <vs-button @click="nextFlow" class="btn-drop px-3 mr-5 mt-2" type="filled" icon="keyboard_arrow_right" icon-after style="float: right !important; border-radius: 12px;">
                    <span>{{ isCreateContext ? 'Próximo/Pular' : 'Atualizar/Pular' }}</span>
                </vs-button>
            </div>
        </vs-popup>
    </div>
</template>

<script>
    import moduleOrder from '@/store/order/moduleOrder';
    import { hasFeature } from "@/utils";
    import vSelect from 'vue-select';

    export default {
        name: 'PaymentPopUp',
        data() {
            return {
                months: 1,
                money_change: 0.0,
                isInputFocused: false,
                hasErpFeature: false,
                collapseKey: 0,
                checks: [
                    {
                        name: 'Dinheiro',
                        selected: false,
                        type: 'cash'
                    },
                    {
                        name: 'Cartão',
                        selected: false,
                        type: 'card',

                    },
                    {
                        name: 'Pix',
                        selected: false,
                        type: 'pix'
                    },
                ],
                paymentModality: null,
            }
        },
        props: {
            isActive: {
                type: Boolean,
                required: true
            },
            dataOfProductsToPreOrder: {
                type: Object|Array,
                required: true
            },
            isCreateContext: {
                type: Boolean,
                required: true
            },
            dataToUpdate: {
                type: Array|Object,
                required: true
            },
            services: {
                type: Object|Array,
                required: true
            }
        },
        async mounted() {
            this.hasErpFeature = await hasFeature('erps')

            this.$events.off('cleanPayment')
            this.$events.on('cleanPayment', ({ file }) => {
                if  ( file === 'Payment' ) {
                    this.defineOption('none')
                    this.collapseKey+= 1;
                    this.months = 1;
                    this.dataOfProductsToPreOrder = {};
                    this.services = [];
                }
            })
        },
        watch: {
            async isActive(val) {
                if (!val) {
                    this.dataOfProductsToPreOrder = {};
                    this.services = [];
                }

                this.money_change = ''
                let total = 0.0;
                
                if (this.isCreateContext) {
                    if (this.dataOfProductsToPreOrder.erpId === null) {
                        delete this.dataOfProductsToPreOrder.erpId;
                    }

                    if (Object.keys(this.dataOfProductsToPreOrder).length !== 0) {
                        await this.dataOfProductsToPreOrder.product.forEach(item => {
                            if (!this.enableNegativeStock && item.integration_id !== null && item.amount <= 0 && this.hasErpFeature) {
                                item.quantity = 0;
                            }

                            total += item.discount_price * item.quantity;
                        });
                    }

                    if (this.services.length !== 0) {
                        await this.services.forEach(item => {
                            total += item.price
                        });
                    }

                    this.money_change = total.toFixed(2);

                    if (this.dataOfProductsToPreOrder.delivery.typeOfDelivery == 'delivery') {
                        this.money_change = (parseFloat(this.money_change)  + parseFloat(this.dataOfProductsToPreOrder.delivery.delivery_fee)).toFixed(2);
                    }
                }
            },
            'isCreateContext'() {
                if (!this.isCreateContext) {
                    this.money_change = ''
                    const parsedData = JSON.parse(this.dataToUpdate.payment_data); 
                    this.defineOption(parsedData.type);

                    this.months = this.option === 'card' ? parsedData.months : 1;
                    this.money_change = (parsedData.money_change === undefined ? this.dataToUpdate.purchase_value : parsedData.money_change).toFixed(2);
                }
            }
        },
        emits: [
            'backToDelivery',
            'updateOrderPayment',
            'isActiveFalse',
            'sendToNotesAndFiles',
            'backToProducts'
        ],
        methods: {
            closePopUp() {
                this.isActive = false;
                this.$emit('isActiveFalse');
            },
            nextFlow() {

                if (this.isCreateContext) {

                    if (this.option === 'card' && !this.paymentModality) {
                        return this.$vs.notify({
                            color: 'danger',
                            title: 'Atenção!',
                            text: 'Adicione a modalidade do cartão! (Crédito ou Débito)'
                        });
                    }

                    if (this.dataOfProductsToPreOrder.payment !== undefined) {
                        delete(this.dataOfProductsToPreOrder['payment']);
                    }

                    switch(this.option) {
                        case 'card':
                            this.dataOfProductsToPreOrder.payment = {
                                type: this.option,
                                months: parseInt(this.months),
                                paymentModality: this.paymentModalityFormatted
                            }
                            break;
                        case 'cash':
                            this.dataOfProductsToPreOrder.payment = {
                                type: this.option,
                                money_change: parseFloat(this.money_change == '' || this.money_change == ' ' ? 0 : this.money_change)
                            }
                            break;
                        case 'pix':
                            this.dataOfProductsToPreOrder.payment = {
                                type: this.option
                            }
                            break;
                        case 'none':
                            this.dataOfProductsToPreOrder.payment = {
                                type: this.option
                            }
                            break;

                    }
                    this.$emit('sendToNotesAndFiles', this.dataOfProductsToPreOrder);
                } else {
                    switch(this.option) {
                    case 'card':
                        this.dataToUpdate.payment_data = {
                            type: this.option,
                            months: parseInt(this.months),
                            paymentModality: this.paymentModalityFormatted
                        }
                        break;
                    case 'cash':
                        this.dataToUpdate.payment_data = {
                            type: this.option,
                            money_change: parseFloat(this.money_change == '' || this.money_change == ' ' ? 0 : this.money_change)
                        }
                        break;
                    case 'pix':
                        this.dataToUpdate.payment_data = {
                            type: this.option
                        }
                        break;
                    }
                    this.dataToUpdate.payment_data = JSON.stringify(this.dataToUpdate.payment_data);

                    this.updatePayment(this.dataToUpdate);

                    this.$emit('updateOrderPayment', this.dataToUpdate);
                    return ;
                }
            },
            async updatePayment(data) {
                if (!moduleOrder.isRegistered) {
                    this.$store.registerModule('order', moduleOrder)
                    moduleOrder.isRegistered = true
                }
                await this.$store.dispatch("order/updatePreOrders", {
                    id: data.id,
                    payment_data: data.payment_data,
                    purchase_value: data.purchase_value,
                    is_delivery: data.is_delivery
                })
                .then((response) => {
                    this.$vs.notify({
                        color: 'success',
                        title: 'Sucesso!',
                        text: 'Atualização feita com sucesso!'
                    })
                })
                .catch((exception) => {
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Erro!',
                        text: 'Erro ao atualizar os dados, por favor nos contate para corrigir-mos!'
                    });
                    console.log(exception);
                });
            },
            highlightInput() {
                this.isInputFocused = !this.isInputFocused;
                if (this.money_change > this.fullPrice) {
                    this.money_change = this.fullPrice
                }
            },
            handleCheckboxClick(type) {
                this.checks.forEach(check => {
                    if (check.type !== type && check.selected) {
                        check.selected = false;
                    }
                });
            },
            defineOption(value) {
                this.checks.forEach(check => {
                    check.selected = check.type === value
                });
            }
        },
        computed: {
            paymentModalityFormatted() {
                return this.paymentModality ? this.paymentModality === 'Crédito' ? 'credit' : 'debit' : null
            },
            option() {
                const option = this.checks.filter(check => check.selected === true)
                const selected = option.length > 0 ? option[0].type : 'none';
                return selected;
            },
            fullPrice() {
                let some = 0;

                this.dataOfProductsToPreOrder.product.forEach(element => {
                    some = some + element.discount_price
                });
                return some.toFixed(2);
            },
            enableNegativeStock() {
                return !!Number(this.$store.state.settings.settings.enable_negative_stock);
            },
        },
        components: {
            vSelect
        }
    }
</script>

<style lang="scss">
    #popUpPayment div.vs-popup {
        .vs-popup--content {
            padding: 15px;
            margin: 0;
        }
        margin: 0;
        border-radius: 18px !important;
        border: solid 1.2px;
        border-color: rgba(18, 17, 17, 0.769);
        width: 850px !important;
        .vs-popup--header {
            background-color: transparent !important;
            .vs-popup--title {
                background-color: transparent !important;
                h3 {
                    background-color: transparent !important;
                }
            }
        }
        header {
            background-color: transparent !important;
        }
        input.vs-inputx.vs-input--input.normal {
            border-radius: 14px !important;
            width: 300px;
        }
        li div:first-of-type {
            height: 70px;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-bottom: 20px;
            > img {
                width: 100px !important;
                display: block !important;
                align-items: center;
                justify-content: center;
            }
        }
        ul.leftx {
            display: flex;
            justify-content: space-evenly;
            flex-direction: row;
            align-items: center;
            text-align: center;
            margin-top: 50px;
        }
        *,
        *::before,
        *::after {
        box-sizing: border-box;
        }
        #myselect {
            width: 150px;
            border-radius: 14px;
            border-color:  #b6bebdd2;
            background-color: transparent;
            height: 35px;
            padding-left: 10px;
            font-size: 15px;
        }
        #myinput {
            box-shadow: none !important;
            border:none !important;
            background-color: transparent;
            height: 35px;
            font-size: 15px;
            background-color: transparent; 
        }
    }
    .background-payment {
        display: flex;
        padding: 24px;
        flex-direction: column;
        align-items: flex-start;
        gap: 32px;
        align-self: stretch;
        border-radius: 16px;
        border: 1px solid #F0F0F0;
        background:#FAFAFA;
        .payment-card {
            display: flex;
            padding: 24px;
            flex-direction: column;
            align-items: flex-start;
            gap: 16px;
            align-self: stretch;
            border-radius: 8px;
            border: 1px solid #DADADA;
            background: #FFF;
            h4 {
                margin-left: 1em;
                color:#565656 !important;
            }
            color:#565656 !important;

            .vs-collapse-item .vs-collapse-item--header {
                padding: 0px !important;
                .vs-component .vs-checkbox{
                    border-radius: 12px !important;
                }
            }

            .vs-input-number {
                background-color: white;
            }
            
        }
        .money-div{
            display: inline-flex; 
            align-items: center; 
            border: 1px solid #b6bebdd2; 
            border-radius: 5px; 
            width:max-content;
            transition:.3s;
        }
        .highlight{
            display: inline-flex; 
            align-items: center; 
            border: 1px solid #409eff !important; 
            box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
            border-radius: 5px; 
            width:max-content;
            transition:.3s;
        }
    }
</style>